import { useQuery } from '@tanstack/react-query'

import { useParamOrFail } from '@/hooks/useParamOrFail'
import { PARAMS } from '@/lib/params'
import { QUERY_KEYS } from '@/lib/queryKeys'
import referralService from '@/lib/services/referralService'

export function useReferralWithESignatureDetailsQuery() {
  const referralId = +useParamOrFail(
    PARAMS.referralESignatureConsent.referralId,
  )
  const callbackCode = useParamOrFail(
    PARAMS.referralESignatureConsent.callbackCode,
  )

  return useQuery({
    queryKey: QUERY_KEYS.referralWithESignatureDetails(referralId),
    queryFn: () =>
      referralService.getReferralWithESignatureDetails(referralId, {
        callbackCode,
      }),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false,
  })
}
